module.exports = __webpack_public_path__ + "static/media/logo.a1073064.svg";